import { ExtraFeature, FeatureStability } from '@g17eco/molecules/feature-stability';
import { BasicAlert } from '@g17eco/molecules/alert';

export const PreviewAlert = () => {
  return (
    <BasicAlert type='info' className='mb-4'>
      <div className='h6 d-flex align-items-center'>
        <FeatureStability feature={ExtraFeature.DataIntegrations} color='text-ThemeAccentExtradark' />
        <span className='ms-2'>Experimental Feature</span>
      </div>
      <div>Please be aware that this feature is experimental and may not work as expected.</div>
    </BasicAlert>
  );
};
